define('Components/ScrollPopinWidget/js/models/ScrollPopinWidgetInstanceModel',['jquery','WidgetInstanceModel','app','UrlFactory'],function($,WidgetInstanceModel,app,UrlFactory){
    return WidgetInstanceModel.extend({
        
    })
})
;
